import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // { path: '/', redirect: '/login' },

  {
    path: '/',
    name: 'login',
    meta: { layout: 'blank' },
    component: () => import('@/views/LoginPage.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: { layout: 'blank' },
    component: () => import('@/views/LoginPage.vue')
  },

  {
    path: '/program/list',
    name: 'Program List',
    meta: { layout: 'default' },
    component: () => import('@/views/pages/program/ProgramList.vue')
  },

  {
    path: '/faculty/list',
    name: 'Faculty List',
    meta: { layout: 'default' },
    component: () => import('@/views/pages/faculty/FacultyList.vue')
  },
  // for trainer list
  {
    path: '/trainer/list',
    name: 'Trainer List',
    meta: { layout: 'default' },
    component: () => import('@/views/pages/trainer/TrainerList.vue')
  },

  {
    path: '/program/dashboard',
    name: 'Program Dashboard',
    meta: { layout: 'default' },
    component: () => import('@/views/pages/program/ProgramDashboard.vue')
  },

  {
    path: '/program-settings/list',
    name: 'Settings List',
    meta: { layout: 'default' },
    component: () => import('@/views/pages/program/ProgramSettingsList.vue')
  },

  {
    path: '/registration/list',
    name: 'Registration List',
    meta: { layout: 'default' },
    component: () => import('@/views/pages/registration/RegistrationList.vue')
  },

  {
    path: '/attendance/list',
    name: 'Attendance List',
    meta: { layout: 'default' },
    component: () => import('@/views/pages/attendance/AttendanceList.vue')
  },

  {
    path: '/provisional-trainer/list',
    name: 'Provisional Trainer List',
    meta: { layout: 'default' },
    component: () => import('@/views/pages/provisional-trainer/ProvisionalTrainerList.vue')
  },

  {
    path: '/event-graduation/list',
    name: 'Trainer Score List',
    meta: { layout: 'default' },
    component: () => import('@/views/pages/trainer-score/TrainerScoreList.vue')
  },

  {
    path: '/event-graduation/update',
    name: 'Trainer Score Update',
    meta: { layout: 'default' },
    component: () => import('@/views/pages/trainer-score/TrainerScoreUpdate.vue')
  },

  {
    path: '/assignment/list',
    name: 'Assignment List',
    meta: { layout: 'default' },
    component: () => import('@/views/pages/assignment/AssignmentList.vue')
  },

  {
    path: '/trainer-assignment/list',
    name: 'Trainer Assignment List',
    meta: { layout: 'default' },
    component: () => import('@/views/pages/assignment-upload/AssignmentUploadList.vue')
  },

  {
    path: '/trainer-assignment/upload',
    name: 'Trainer Assignment Upload',
    meta: { layout: 'default' },
    component: () => import('@/views/pages/assignment-upload/AssignmentUploadEdit.vue')
  },

  {
    path: '/feedback/list',
    name: 'Feedback Form List',
    meta: { layout: 'default' },
    component: () => import('@/views/pages/feedback/FeedbackList.vue')
  },

  {
    path: '/participant-feedback',
    name: 'Participant Feedback',
    meta: { layout: 'blank' },
    component: () => import('@/views/ParticipantFeedback.vue')
  },

  {
    path: "*",
    name: '404',
    meta: { layout: 'blank' },
    component: () => import('@/views/NotFoundPage.vue')
  },

  {
    path: "/access-denied",
    name: 'Access Denied',
    meta: { layout: 'blank' },
    component: () => import('@/views/AccessDenied.vue')
  },

]

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    console.log({ to });
    console.log({ from });
    console.log({ savedPosition });
    return { x: 0, y: 0 }
  }
});

router.beforeEach(async (to, from, next) => {
  var ToName = to.name;
  console.log({ ToName });

  var fromPath = from.path;
  var toPath = to.path;
  console.log("navigation from=" + fromPath + ", to=" + toPath);

  var token = localStorage.getItem("token");
  token = token == (null || undefined) ? "" : token;
  console.log({ token });

  if (
    to.path == "/" ||
    to.path == "/login" ||
    to.path == "/participant-feedback" ||
    to.path == "/*"
  ) {
    console.log("navigation true");
    next();
  } else {
    console.log("navigation false");
    if (token != "") {
      console.log("token is valid");
      next();
    } else {
      console.log("session is expired");
      router.push("/login");
    }
  }
});


export default router
